import classNames from "classnames";
import React, {
    HTMLAttributes, ReactElement, ReactNode,
} from "react";
import Styles from "./Table.module.scss";
import useTableData, { ContainsId } from "./base";

export interface TableContainerProps<T> extends Omit<HTMLAttributes<HTMLTableCellElement>, "children"> {
    columnKey: string;
    title: string;
    children: (item: T) => ReactNode;
    sortBy?: (item: T) => string | number | unknown;
}

function TableValue<T extends ContainsId>(args: TableContainerProps<T>): ReactNode {
    const {
        children,
        columnKey: key,
        className,
        title,
        sortBy,
    } = args;

    const data = useTableData<T>();
    data.useColumn(key, title, children, classNames(Styles["table-cell"], className), sortBy);

    return null;
}

TableValue.defaultProps = {
    canSort: false,
    canFilter: false,
};

export type TableValueType<T> = (
    props: TableContainerProps<T> & { ref?: React.ForwardedRef<HTMLTableCellElement> }
) => ReactElement;

export default TableValue as TableValueType<unknown>;
